import { Interval } from 'luxon';

import merchantGatewayApi from 'apis/merchant-gateway/api';
import { EntityType } from 'common/types';

import {
  CustomerBaseTotalsInsight,
  CustomersByCustomerTypeInsight,
  CustomersByOrderTypeInsight,
  CustomersTotalInsight,
} from './types';
import { getBaseUrlV2, getDateRangeForApiCall } from '../utils';

export const getCustomersTotalInsightForEntity = (entityType: EntityType, entityId: string, interval: Interval) => {
  return merchantGatewayApi
    .get<CustomersTotalInsight>(`${getBaseUrlV2(entityType, entityId)}/total-customers`, {
      params: getDateRangeForApiCall(interval),
    })
    .then(response => response.data);
};

export const getCustomerBaseTotalsInsightForEntity = (entityType: EntityType, entityId: string, interval: Interval) => {
  return merchantGatewayApi
    .get<CustomerBaseTotalsInsight>(`${getBaseUrlV2(entityType, entityId)}/customers/total`, {
      params: getDateRangeForApiCall(interval),
    })
    .then(response => response.data);
};

export const getCustomersByOrderTypeInsightForEntity = (
  entityType: EntityType,
  entityId: string,
  interval: Interval,
) => {
  return merchantGatewayApi
    .get<CustomersByOrderTypeInsight>(`${getBaseUrlV2(entityType, entityId)}/customers/by-subscription`, {
      params: getDateRangeForApiCall(interval),
    })
    .then(response => response.data);
};

export const getCustomersByCustomerTypeInsightForEntity = (
  entityType: EntityType,
  entityId: string,
  interval: Interval,
) => {
  return merchantGatewayApi
    .get<CustomersByCustomerTypeInsight>(`${getBaseUrlV2(entityType, entityId)}/customers/returning-vs-ftu`, {
      params: getDateRangeForApiCall(interval),
    })
    .then(response => response.data);
};
